<template>
  <span
    class="alice-avatar"
    :class="{ 'alice-avatar--ring': ring }"
    :style="rootStyle"
  >
    <img
      v-if="photo"
      :src="photo"
      :alt="name || ''"
      class="alice-avatar__img"
      @error="photoFailed = true"
      v-show="!photoFailed"
    />
    <span v-if="!photo || photoFailed" class="alice-avatar__initials">{{
      derivedInitials
    }}</span>
  </span>
</template>

<script>
import { initialsFromName } from "./normalize";

export default {
  name: "AliceAvatar",
  props: {
    name: { type: String, default: "" },
    initials: { type: String, default: "" },
    photo: { type: String, default: "" },
    color: { type: String, default: "var(--vp-grijs-20)" },
    size: { type: [Number, String], default: 28 },
    ring: { type: Boolean, default: false },
  },
  data() {
    return { photoFailed: false };
  },
  computed: {
    derivedInitials() {
      if (this.initials) return this.initials;
      return initialsFromName(this.name);
    },
    rootStyle() {
      const s = Number(this.size);
      return {
        width: `${s}px`,
        height: `${s}px`,
        background:
          this.photo && !this.photoFailed ? "transparent" : this.color,
        fontSize: `${Math.round(s * 0.42)}px`,
      };
    },
  },
  watch: {
    photo() {
      this.photoFailed = false;
    },
  },
};
</script>

<style scoped>
.alice-avatar {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 0;
  overflow: hidden;
  color: var(--vp-black);
  font-family: var(--font-ui);
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1;
}
.alice-avatar--ring {
  box-shadow: inset 0 0 0 2px var(--vp-black);
}
.alice-avatar__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.alice-avatar__initials {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
